import styled from 'styled-components';
import colors from 'Styles/colors';
import { fadeIn } from 'Styles/effects';
import { ReactComponent as LightLogo } from 'Images/faraday_logo.svg';
import { ReactComponent as DarkLogo } from 'Images/faraday-logo-dark.svg';

export const Wrapper = styled.div`
  z-index: 9999;
  width: 100%;
  height: 100vh;
  position: fixed;
  bottom: 0px;
  text-align: center;
  left: 0;


  background-color: rgba(0,0,0,0.5);

  ${fadeIn}
`;
Wrapper.displayName = 'Wrapper';

export const Container = styled.div`
  width: 90%;
  background: ${({ theme }) => theme.backgrounds.modal};
  padding: 1.5rem 0.5rem;
  box-shadow: ${({ theme }) => theme.boxShadow.modal};

  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);



  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

`;
Container.displayName = 'Container';

export const Title = styled.div`
  font-size: 17px;
  font-weight: 500;
  line-height: 2.08;
  color: ${({ theme }) => theme.text.modalTitle2};
  font-weight: 600;
  margin: 0 10px;
`;
Title.displayName = 'Title';

export const Text = styled.div`
  display: inline-flex;
  font-family: SequelSans-RomanHead;
  font-size: 17px;
  font-weight: 100;
  color: ${({ theme }) => theme.text.modalDescription2};

  flex-basis: max-content;
  margin-top: 2px;
`;
Text.displayName = 'Text';

export const Close = styled.button`
  float: right;
  border: 0;
  height: 20px;
  width: 20px;
  line-height: 20px;
  background: inherit;
  color: ${({ theme }) => theme.text.modalTitle2};

  position: absolute;
  top: 10px;
  right: 20px;
`;
Close.displayName = 'Close';

export const Link = styled.a`
  margin: 0 5px;
  color: ${colors.blueCerulean};
`;
Link.displayName = 'Link';

export const Logo = styled.img`
  width: 97px;
  margin: 0 30px;
`;

export const LogoLight = styled(LightLogo)`
  width: 97px;
  margin: 0 30px;
`;
LogoLight.displayName = LogoLight;

export const LogoDark = styled(DarkLogo)`
  /* width: 97px; */
  margin: 0 30px;
`;
LogoDark.displayName = LogoDark;
